export function en() {
	return {
		'form': {
			'from': 'From',
			'to': 'To',
			'username': 'Username',
			'password': 'Password',
			'type': 'Type',
			'status': 'Status',
			'transactionPassword': 'Transaction Password',
			'confirmUsername': 'Confirm Username',
			'confirmPassword': 'Confirm Password',
			'confirmTransactionPassword': 'Confirm Transaction Password',
			'paymentOption': 'Payment Option',
			'fromProduct': 'From Product',
			'email': 'Email',
			'website': 'Website',
			'promotion': 'Promotion',
			'advertisement': 'Advertisement',
			'language': 'Language',
			'size': 'Size',
			'campaign': 'Campaign Name',
			'referralCode': 'Referral Code',
			'newPassword': 'New Password',
			'iban': 'Account Number/IBAN',
			'accountName': 'Account Name / Company Name',
			'birthDate': 'Date of Birth',
			'citizenship': 'Citizenship',
			'address': 'Address',
			'swift': 'Bank Code (BIC) / SWIFT',
			'bankName': 'Bank Name',
			'bankAddress': 'Bank Address',
			'isDefault': 'Use as default',
		},
		'titles': {
			'bankAccount': 'Bank Account',
			'dashboard': 'Dashboard',
			'account': 'My Account',
			'profile': 'My Profile',
			'transaction': 'Transactions',
			'transactionHistory': 'Transaction History',
			'overview': 'Overview',
			'deposit': 'Deposit',
			'withdrawal': 'Withdrawal',
			'transfer': 'Transfer',
			'productWallet': 'Transfer (Product Wallet)',
			'p2pTransfer': 'Transfer (Peer to Peer)',
			'skypeBetting': 'Skype Betting',
			'outstandingBets': 'Outstanding Bets',
			'betHistory': 'Bet History',
			'betOverview': 'Bet Overview',
			'affiliate': 'Affiliate',
			'affiliateDashboard': 'Affiliate Dashboard',
			'affiliateTools': 'Affiliate Tools',
			'supportTickets': 'Support Tickets',
			'settings': 'Settings',
			'mobileSite': 'AMS Mobite Site',
			'Valid Turnover/Commissions': 'Valid Turnover/Commissions',
			'products': 'Products',
			'size': 'Size',
			'campaign': 'Campaign Name',
			'referralCode': 'Referral Code',
			'website': 'Website',
			'tickets': 'Support Tickets',
		},
		'tables': {
			'product': 'Product',
			'memberId': 'Member ID',
			'totalTurnover': 'Total TO',
			'totalWinLoss': 'Total Customer W/L',
			'totalCommission': 'Affiliate Commission',
			'date': 'Date',
			'transactionNumber': 'Transaction #',
			'type': 'Type',
			'language': 'Language',
			'currency': 'Currency',
			'paymentOption': 'Payment Option',
			'amount': 'Amount',
			'status': 'Status',
			'Total Commission': 'Total Commission',
			'subject': 'Subject',
			'description': 'Description',
			'username': 'Username',
			'balance': 'Balance',
			'dateLastUpdated': 'Date Last Updated'
		},
		'Reset password': 'Reset password',
		'Activate Later': 'Activate Later',
		"You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "You're on your way to earning a lifetime commission. Just follow 4 easy steps.",
		'I confirm that I have read and accepted': 'I confirm that I have read and accepted',
		'Asianconnect Affiliates Terms and Conditions': 'Asianconnect Affiliates Terms and Conditions',
		'Get Started': 'Get Started',
		'Banners and Referral Codes': 'Banners and Referral Codes',
		'Learn more': 'Learn more',
		'Archive': 'Archive',
		'generateBannerNote': 'Simply fill out the form with the details of your campaign and we\'ll generate a unique referral link and a downloadable banner for you.',
		'Setup your username and password now': 'Setup your username and password now',
		'Welcome to AC Affiliates!': 'Welcome to AC Affiliates!',
		'Please enter your Campaign Name': 'Please enter your Campaign Name',
		'Please enter your Referral Code': 'Please enter your Referral Code',
		'Get code': 'Get code',
		'Reset': 'Reset',
		'Generate': 'Generate',
		'referralCodeNote': 'You can reuse your existing Referral Code URL or create a new one. Special characters and spaces are not allowed.',
		'Special characters and spaces are not allowed.': 'Special characters and spaces are not allowed.',
		'See Preview': 'See Preview',
		'Preview': 'Preview',
		'Please enter your website URL': 'Please enter your website URL',
		'Please contact Customer Support.': 'Please contact Customer Support.',
		'Change email': 'Change email',
		'Transfer from': 'Transfer from',
		'Transfer to': 'Transfer to',
		'Product': 'Product',
		'Please Select': 'Please Select',
		'Commission Period': 'Commission Period',
		'Original Payout Date': 'Original Payout Date',
		'to': 'to',
		'Reason': 'Reason',
		'commission': 'commission',
		'Search': 'Search',
		'Reset Filter': 'Reset Filter',
		'All Status': 'All Status',
		'Product Username': 'Product Username',
		'All Payment Options': 'All Payment Options',
		'All types': 'All types',
		'Sign In': 'Sign In',
		'Sign in to start your session': 'Sign in to start your session',
		'Please wait, Logging in...': 'Please wait, Logging in...',
		'signOut': 'Sign out',
		'memberSince': 'Member Since',
		'Note:': 'Note:',
		'Note': 'Note',
		'makeDeposit': 'Make a deposit to increase your funds.',
		'welcome': 'Welcome to Asianconnect Member Site!',
		'setup': 'Setup your username and password now',
		'to activate your account.': 'to activate your account.',
		'setupNote': 'Note: Your temporary username and password was sent to your email.',
		'Proceed': 'Proceed',
		'Deposit Now': 'Deposit Now',
		'Available Balance': 'Available Balance',
		'Unallocated Balance': 'Unallocated Balance',
		'Account Status': 'Account Status',
		'Quick Links': 'Quick Links',
		'BETA': 'BETA',
		'Verified': 'Verified',
		'Not Verified': 'Not Verified',
		'Filter': 'Filter',
		'Request Transfer': 'Request Transfer',
		'loadingPageContent': 'Loading page content, please wait...',
		'Date Covered:': 'Date Covered:',
		'Total Turnover:': 'Total Turnover:',
		'Total Affiliate Commission:': 'Total Affiliate Commission:',
		'Total Customer W/L:': 'Total Customer W/L:',
		'exportCsv': 'Export as CSV',
		'noProduct': 'No Product',
		'somethingWentWrong': 'Something went wrong. Please check your details.',
		'activated': 'You have successfully activated your account.',
		'Account Activation': 'Account Activation',
		'activateAccountNote': 'Activate your account by filling out your credentials below.',
		'usernameValidation': 'Must contain letters, numbers and underscore only.',
		'passwordValidation': 'Must be least 8 characters, contain at least 2 letters, 2 digits and 2 symbols.',
		'transactionPasswordValidation': 'Must be alpha numeric, min 6 chars and should have at least 1 capital letter.',
		'Re-enter username': 'Re-enter username',
		'Re-enter password': 'Re-enter password',
		'Re-enter transaction password': 'Re-enter transaction password',
		'Activate account': 'Activate account',
		'Clear All': 'Clear All',
		'skrillContent': 'Please login to your SKRILL account and transfer the requested funds to ',
		'netellerContent': 'Please login to your NETELLER account and transfer the requested funds to ',
		'verifyDeposit': 'We are now verifying your deposit. Once we received your deposit, you will see the additional funds reflected in your account.',
		'netellerTransferNote': 'Please login to your NETELLER account and transfer the requested funds to ',
		'netellerTransferNote2': 'with transfer code of ',
		'you will see the additional funds reflected in your account.': 'you will see the additional funds reflected in your account.',
		'CONTINUE': 'CONTINUE',
		'cantProcessRequest': "Sorry We've not been able to process your request at this time",
		'Sorry': 'Sorry',
		'Thank you': 'Thank you',
		'OK': 'OK',
		'For making a deposit': 'For making a deposit',
		'We are now verifying your deposit. Once we have received your deposit,': 'We are now verifying your deposit. Once we have received your deposit,',
		'bankNotice': 'Bank transactions are not possible as of the moment. For inquiries, please contact customer support. Thank you.',
		'bankRestricted': 'Bank transaction is restricted in your country. Please use other payment methods.',
		'processingTime': 'Processing time',
		'fee': 'Fee',
		'minimumDeposit': 'Minimum Deposit Amount',
		'maximumDeposit': 'Maximum Deposit Amount',
		'chooseProductDeposit': 'Simply choose your preferred product (bookie), enter the amount then click the Request Deposit.',
		'Product Name': 'Product Name',
		'Amount': 'Amount',
		'fileValidation': 'Only jpg, jpeg and png file with maximum of 2 MB is allowed.',
		'Transaction Summary': 'Transaction Summary',
		'Total amount to be deposited in your account': 'Total amount to be deposited in your account',
		'Total amount to be sent in your account': 'Total amount to be sent in your account',
		'You have submitted the BTC deposit request form.': 'You have submitted the BTC deposit request form.',
		'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Please send the BTC amount to the BTC address below. This address is unique to your account.',
		'Tap or Scan to pay': 'Tap or Scan to pay',
		'Show QR': 'Show QR',
		'Total BTC to be sent': 'Total BTC to be sent',
		'Recipient BTC Address': 'Recipient BTC Address',
		'Please send total BTC to the recipient address.': 'Please send total BTC to the recipient address.',
		'Copy': 'Copy',
		'Rate Used per BTC': 'Rate Used per BTC',
		'Please send bitcoin in': 'Please send bitcoin in',
		'minutes.': 'minutes.',
		'This page will automatically refresh when Bitcoin has been sent.': 'This page will automatically refresh when Bitcoin has been sent.',
		'Thank you for sending the requested amount!': 'Thank you for sending the requested amount!',
		'We are now waiting for your Bitcoin confirmations.': 'We are now waiting for your Bitcoin confirmations.',
		'confirmation(s) received': 'confirmation(s) received',
		'Status': 'Status',
		'Thank you for making a deposit!': 'Thank you for making a deposit!',
		'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.',
		'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.',
		'Requested: waiting to receive bitcoin': 'Requested: waiting to receive bitcoin',
		'Note: Please contact Support if you made a request by mistake and would like to request again': 'Note: Please contact Support if you made a request by mistake and would like to request again',
		'bitcoinDeclined': "Sorry, your request was DECLINED probably because we did not receive the bitcoin. If this is a mistake, please contact Support and we'll assist you right away.",
		'Close': 'Close',
		'Exchange Rate': 'Exchange Rate',
		'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.',
		'Total BTC amount to send:': 'Total BTC amount to send:',
		'Total EUR amount to receive:': 'Total EUR amount to receive:',
		'Transaction Status': 'Transaction Status',
		'Requested': 'Requested',
		'Pending Confirmation': 'Pending Confirmation',
		'Confirmed': 'Confirmed',
		'Declined': 'Declined',
		'Voided': 'Voided',
		'Account ID': 'Account ID',
		'Amount to deposit': 'Amount to deposit',
		'Total amount to deposit': 'Total amount to deposit',
		'Free': 'Free',
		'Add product': 'Add product',
		'Make new request': 'Make new request',
		'we will send you the username and password of your newly registered account.': 'we will send you the username and password of your newly registered account.',
		'Total amount to be deposited on account': 'Total amount to be deposited on account',
		'Total amount to be deducted from account': 'Total amount to be deducted from account',
		'Total amount to be sent': 'Total amount to be sent',
		'Total amount to be received': 'Total amount to be received',
		'Enter product username': 'Enter product username',
		'Total amount to send': 'Total amount to send',
		'Request is successfully created!': 'Request is successfully created!',
		'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Please wait for customer service confirmation. You can view transaction status in Transactions overview.',
		'Unable to Transfer': 'Unable to Transfer',
		'Please contact our customer service team to have your account verified. Thank you.': 'Please contact our customer service team to have your account verified. Thank you.',
		'No product(s) available for selection.': 'No product(s) available for selection.',
		'Opps, amount is not enough!': 'Opps, amount is not enough!',
		'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'Minimum amount that can be withdrawn is 100 EUR/GBP.',
		'Do you want ': 'Do you want ',
		'to be your default bank for withdrawal?': 'to be your default bank for withdrawal?',
		'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.',
		'Minimum Withdrawal Amount': 'Minimum Withdrawal Amount',
		'Maximum Withdrawal Amount': 'Maximum Withdrawal Amount',
		'Bank Account': 'Bank Account',
		'Link new bank account': 'Link new bank account',
		'transactionPasswordHint': 'Hint: If you have been an existing customer since March 2017 and haven\'t set your transaction password, this is your answer to the security question: What is your dream job?',
		'Beneficiary name': 'Beneficiary name',
		'Beneficiary address': 'Beneficiary address',
		'IBAN': 'IBAN',
		'Bank name': 'Bank name',
		'Bank address': 'Bank address',
		'SWIFT': 'SWIFT',
		'Total amount to be deducted from your account': 'Total amount to be deducted from your account',
		'Total amount to be received in your account': 'Total amount to be received in your account',
		'Confirmation Message': 'Confirmation Message',
		'Yes': 'Yes',
		'No': 'No',
		'confirmations': 'confirmations',
		'Please select product(s) where you want to withdraw, and input the amount in': 'Please select product(s) where you want to withdraw, and input the amount in',
		'or BTC': 'or BTC',
		'Total BTC': 'Total BTC',
		'SEND TO': 'SEND TO',
		'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.',
		'Total BTC amount to receive': 'Total BTC amount to receive',
		'Total': 'Total',
		'amount to be deducted': 'amount to be deducted',
		'Amount to deduct': 'Amount to deduct',
		'Total amount to receive': 'Total amount to receive',
		'Opps, we need to know where to wire your funds.': 'Opps, we need to know where to wire your funds.',
		'Please fill in the required bank details. Thank you!': 'Please fill in the required bank details. Thank you!',
		'Unable to withdraw': 'Unable to withdraw',
		'Invalid Action!': 'Invalid Action!',
		'A product where the fee should be charged is required.': 'A product where the fee should be charged is required.',
		'Reset link was sent to your email.': 'Reset link was sent to your email.',
		'Success!': 'Success!',
		'Send reset password link': 'Send reset password link',
		"Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Enter the email you use for Asianconnect88, and we'll help you create a new password.",
		'English': 'English',
		'French': 'French',
		'German': 'German',
		'Spanish': 'Spanish',
		'Asian Odds': 'Asian Odds',
		'Note: Referral URL is your unique link where you can share to everyone': 'Note: Referral URL is your unique link where you can share to everyone',
		'Referral HTML Code': 'Referral HTML Code',
		'copyReferralCodeNote': 'Simply copy, or download the HTML code of your campaign and paste in on the section where you wish the banner to be displayed on your website.',
		'Download HTML': 'Download HTML',
		'Terms and Conditions': 'Terms and Conditions',
		'and': 'and',
		'Commission Scheme': 'Commission Scheme',
		'apply': 'apply',
		'Referral URL': 'Referral URL',
		'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.',
		'Information': 'Information',
		'Get a unique tracking link for your campaign.': 'Get a unique tracking link for your campaign.',
		'Website. Input your website URL.': 'Website. Input your website URL.',
		'Banner type. Pick a banner type: (language/size/promo)': 'Banner type. Pick a banner type: (language/size/promo)',
		'Campaign. Name your campaign.': 'Campaign. Name your campaign.',
		'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.',
		'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.',
		'campaignNote': 'Simply copy, or download the HTML code of your campaign and paste it on the section where you wish the banner to be displayed on your website.',
		'Preview archived banner': 'Preview archived banner',
		'Uploaded': 'Uploaded',
		'Drag and drop files here or': 'Drag and drop files here or',
		'Select file(s)': 'Select file(s)',
		'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.',
		'file(s) selected. Click upload to proceed.': 'file(s) selected. Click upload to proceed.',
		'The file is too large (MB). Allowed maximum size is 2MB.': 'The file is too large (MB). Allowed maximum size is 2MB.',
		'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.',
		'Successfully uploaded!': 'Successfully uploaded!',
		'Documents uploaded': 'Documents uploaded',
		'Delete Document': 'Delete Document',
		'Are you sure you want to delete this document?': 'Are you sure you want to delete this document?',
		'Cancel': 'Cancel',
		'Delete': 'Delete',
		'Account Information': 'Account Information',
		'Customer ID': 'Customer ID',
		'Full name': 'Full name',
		'Currency': 'Currency',
		'Country': 'Country',
		'Date of birth': 'Date of birth',
		'Join date': 'Join date',
		'Email Address': 'Email Address',
		'Phone number': 'Phone number',
		'Skype': 'Skype',
		'Username': 'Username',
		'K.Y.C documents': 'K.Y.C documents',
		'Password changed.': 'Password changed.',
		'I want to request a new reset code.': 'I want to request a new reset code.',
		'Loading, please wait...': 'Loading, please wait...',
		'Request new reset code?': 'Request new reset code?',
		'Enter your new account password below.': 'Enter your new account password below.',
		'Account password has been successfully updated!': 'Account password has been successfully updated!',
		'Update AMS account password': 'Update AMS account password',
		'Current AMS password': 'Current AMS password',
		'New AMS Password': 'New AMS Password',
		'Enter current password': 'Enter current password',
		'Enter new password': 'Enter new password',
		'Confirm new password': 'Confirm new password',
		'Update': 'Update',
		'Are you sure you want to delete this Bank Account?': 'Are you sure you want to delete this Bank Account?',
		'Add bank accounts for faster transaction.': 'Add bank accounts for faster transaction.',
		'Default': 'Default',
		'Link a new bank account': 'Link a new bank account',
		'Bank account successfully deleted.': 'Bank account successfully deleted.',
		'Success': 'Success',
		'Transaction password has been successfully updated!': 'Transaction password has been successfully updated!',
		'Update AMS transaction password': 'Update AMS transaction password',
		'Current AMS transaction password': 'Current AMS transaction password',
		'Enter current transaction password': 'Enter current transaction password',
		'New AMS transaction password': 'New AMS transaction password',
		'Enter new transaction password': 'Enter new transaction password',
		'Confirm new transaction password': 'Confirm new transaction password',
		'Account username has been successfully updated!': 'Account username has been successfully updated!',
		'Update AMS username': 'Update AMS username',
		'Current AMS username': 'Current AMS username',
		'New AMS username': 'New AMS username',
		'Enter new username': 'Enter new username',
		'Confirm new username': 'Confirm new username',
		'Enter password': 'Enter password',
		'Security': 'Security',
		'Update your Username, Account and Transaction Password': 'Update your Username, Account and Transaction Password',
		'Temporarily Unavailable': 'Temporarily Unavailable',
		'For inquiries, please contact Customer Support.': 'For inquiries, please contact Customer Support.',
		'Payment Option': 'Payment Option',
		'Manage your payment accounts': 'Manage your payment accounts',
		'Open': 'Open',
		'Pending': 'Pending',
		'Resolved': 'Resolved',
		'Closed': 'Closed',
		'Forbidden!': 'Forbidden!',
		'My Products': 'My Products',
		'Add Product': 'Add Product',
		'Reset Product Password': 'Reset Product Password',
		'New': 'New',
		'Bank account successfully created.': 'Bank account successfully created.',
		'Link a bank account': 'Link a bank account',
		'Enter Account Number': 'Enter Account Number',
		'Enter Account Name': 'Enter Account Name',
		'Enter Citizenship': 'Enter Citizenship',
		'Enter Address': 'Enter Address',
		'Enter Bank Code': 'Enter Bank Code',
		'Enter Bank Name': 'Enter Bank Name',
		'Enter Bank Address': 'Enter Bank Address',
		'Save bank account': 'Save bank account',
		'Save': 'Save',
		'Limit Reached!': 'Limit Reached!',
		'Go to Settings': 'Go to Settings',
		'Product password successfully requested.': 'Product password successfully requested.',
		'Warning': 'Warning',
		'Something went wrong. Please try again later.': 'Something went wrong. Please try again later.',
		'Request Product Password': 'Request Product Password',
		'Select one or more products to reset password': 'Select one or more products to reset password',
		'View Password': 'View Password',
		'Expires on': 'Expires on',
		'Expired Password': 'Expired Password',
		'No Password': 'No Password',
		'Enter Transaction Password': 'Enter Transaction Password',
		'Request': 'Request',
		'Product password will be available once password has been reset.': 'Product password will be available once password has been reset.',
		'Warning!': 'Warning!',
		'Warning! The following product/s has pending request': 'Warning! The following product/s has pending request',
		'Request Product': 'Request Product',
		'Please select at least one product below': 'Please select at least one product below',
		'No products available. You already have all the products Asianconnect offers.': 'No products available. You already have all the products Asianconnect offers.',
		'username': 'username',
		'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'SINGBET FORCED POSITION TAKING ON ASIANCONNECT',
		'Profit and Loss (PnL)': 'Profit and Loss (PnL)',
		'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.',
		'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).',
		'Then if you lose, you only lose 400 EUR/GBP.': 'Then if you lose, you only lose 400 EUR/GBP.',
		'Deposits': 'Deposits',
		'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.',
		'Withdrawals': 'Withdrawals',
		'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.',
		'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.',
		'I agree to the Terms and Conditions': 'I agree to the Terms and Conditions',
		'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'MAXBET FORCED POSITION TAKING ON ASIANCONNECT',
		'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.',
		'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).',
		'Then if you lose, you only lose 500 EUR/GBP.': 'Then if you lose, you only lose 500 EUR/GBP.',
		'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.',
		'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.',
		'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.',
		'SBOBET Forced Position Taking ON ASIANCONNECT': 'SBOBET Forced Position Taking ON ASIANCONNECT',
		'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.',
		'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.',
		'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.',
		'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.',
		'9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': '9WICKETS FORCED POSITION TAKING ON ASIANCONNECT',
		'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Please note that 9wickets have 3% commission rate applied to your winnings.',
		'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.',
		'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'ORBITX FORCED POSITION TAKING ON ASIANCONNECT',
		'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Please note that OrbitX have 3% commission rate applied to your winnings.',
		'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.',
		'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT',
		'You can contact us via Skype at': 'You can contact us via Skype at',
		'NV for Skype betting Terms and Conditions.': 'NV for Skype betting Terms and Conditions.',
		'Successfully added!': 'Successfully added!',
		'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.',
		'About Us': 'About Us',
		'Contact Us': 'Contact Us',
		'Legal Disclaimer': 'Legal Disclaimer',
		'Privacy Policy': 'Privacy Policy',
		'Go To Transaction Overview': 'Go To Transaction Overview',
		'Notification': 'Notification',
		'was deleted.': 'was deleted.',
		'Failed to delete': 'Failed to delete',
		'file has been uploaded.': 'file has been uploaded.',
		'Failed to upload': 'Failed to upload',
		'Paste an address where you want to receive BTC': 'Paste an address where you want to receive BTC',
		'New referral': 'New referral',
		'has been linked.': 'has been linked.',
		'Referral': 'Referral',
		'has been unlinked.': 'has been unlinked.',
		'Product/s': 'Product/s',
		'has been added.': 'has been added.',
		'Transaction': 'Transaction',
		'has been': 'has been',
		'Deposit': 'Deposit',
		'Withdraw': 'Withdraw',
		'Transfer': 'Transfer',
		'P2P Transfer': 'P2P Transfer',
		'Approved': 'Approved',
		'Acknowledged': 'Acknowledged',
		'Processed': 'Processed',
		'Saved': 'Saved',
		'Invalid Credentials!': 'Invalid Credentials!',
		'Email': 'Email',
		'Name': 'Name',
		'Request Deposit': 'Request Deposit',
		'Request Withdrawal': 'Request Withdrawal',
		'Upload': 'Upload',
		'W/L': 'W/L',
		'Bonus': 'Bonus',
		'Revenue Share': 'Revenue Share',
		'Total W/L:': 'Total W/L:',
		'Total Bonus:': 'Total Bonus:',
		'Total Revenue Share:': 'Total Revenue Share:',
		'Unlimited': 'Unlimited',
		'Instant': 'Instantané',
		'My Tickets': 'My Tickets',
		'Product is required': 'Product is required',
		'Transaction password invalid': 'Transaction password invalid',
		'Transaction deposit has been saved': 'Transaction deposit has been saved',
		'Product has been added': 'Product has been added',
		'Transaction withdrawal has been saved': 'Transaction withdrawal has been saved',
		'Transaction transfer has been saved': 'Transaction transfer has been saved',
		'Transaction deposit has been declined': 'Transaction deposit has been declined',
		'Transaction withdrawal has been declined': 'Transaction withdrawal has been declined',
		'Transaction transfer has been declined': 'Transaction transfer has been declined',
		'Transaction deposit has been voided': 'Transaction deposit has been voided',
		'Transaction withdrawal has been voided': 'Transaction withdrawal has been voided',
		'Transaction transfer has been voided': 'Transaction transfer has been voided',
		'Documents uploaded:': 'Documents uploaded:',
		'Warning! At least one product is required.': 'Warning! At least one product is required.',
		'paymentOptionsViewDetails': 'Important: After making a deposit, fill out this area. Failure to do so will make your deposit invalid. This is to alert us of your deposit transaction so we can verify if your deposit has already reflected on your account.',
		'File(s) still uploading, please wait.': 'File(s) still uploading, please wait.',
		'DEPOSIT': 'DEPOSIT',
		'WITHDRAWAL': 'WITHDRAWAL',
		'TRANSFER': 'TRANSFER',
		'BONUS': 'BONUS',
		'PSP TRANSFER': 'PSP TRANSFER',
		'COMMISSION': 'COMMISSION',
		'DEBIT': 'DEBIT',
		'CREDIT': 'CREDIT',
		'REVENUE SHARE': 'REVENUE SHARE',
		'RESET BOOKIE PASSWORD': 'RESET BOOKIE PASSWORD',
		'Ecopayz Merchant Account (EUR)': 'Ecopayz Merchant Account (EUR)',

	}
}


// WEBPACK FOOTER //
// ./client/app/shared/locales/locale-en.js